module.exports = __webpack_public_path__ + "static/assist-card-a6d7f6d35595262fa32e0faec851ecf8.png";